<!-- FILE GENERATED BY packages/components/design-tokens/build-scripts/generate-icons.js DO NOT CHANGE -->

<svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    data-token-name="IconPlayRound_24"
    viewBox="0 0 24 24"
    aria-hidden="true"
>
    <path
        fill="currentColor"
        fill-rule="evenodd"
        d="M12 22c5.523 0 10-4.477 10-10S17.523 2 12 2 2 6.477 2 12s4.477 10 10 10m-1.25-6.969 4.5-2.598a.5.5 0 0 0 0-.866l-4.5-2.598a.5.5 0 0 0-.75.433v5.196a.5.5 0 0 0 .75.433"
        clip-rule="evenodd"
    />
</svg>
